<template>
  <div class="repeat-group option-group d-flex w-75">
    <template v-if="basicLang">
      <input type="text" class="form-control custom-input w-75" v-model="name">
    </template>
    <template v-else>
      <input type="text" class="form-control custom-input w-75"
             :placeholder="name"
             v-model="translate.name"
             @update:modelValue="e => setTranslate('name',e)">
    </template>
    <div class="img-upload btn-icon btn-rounded btn-icon-transparent" @click="openFileManager">
      <span class="icon icon-picture"></span>
      <span class="loaded-picture bg" :style="{'background-image': $filters.backgroundImage(item.image)}"></span>
    </div>
    <div class="button-group d-flex">
      <div class="button-group-name">
        {{ $static('option.btngr', 'Дії:') }}
      </div>
      <div class="buttons d-flex">
        <Popper arrow :content="$static('option.up', 'Нагору')" hover placement="top" style="white-space: nowrap">
          <button class="remove btn-icon btn-rounded btn-icon-transparent" @click="up">
            <span class="icon icon-up"></span>
          </button>
        </Popper>
        <Popper arrow :content="$static('option.down', 'Вниз')" hover placement="top" style="white-space: nowrap">
          <button class="remove btn-icon btn-rounded btn-icon-transparent" @click="down">
            <span class="icon icon-down"></span>
          </button>
        </Popper>
        <Popper arrow :content="$static('option.del', 'Видалити')" hover placement="top" style="white-space: nowrap">
          <button class="remove btn-icon btn-rounded btn-icon-transparent btn-remove" @click="remove">
            <span class="icon icon-trash"></span>
          </button>
        </Popper>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name    : 'OptionEditor',
    props   : ['item', 'lang'],
    events  : [
      'up',
      'down',
      'remove',
    ],
    computed: {
      name:{
        get() {
          return this.item ? this.item.name : ''
        },
        set(value) {
          if (this.item){
            this.item.name = value
          }
        }
      },
      basicLang() {
        return this.lang === ''
      },
      translate: {
        get() {
          return this.lang && this.item && this.item.translate && this.item.translate[this.lang] ? this.item.translate[this.lang] : {}
        },
        set(value) {
        }
      },
    },
    methods : {
      setTranslate(key, value) {
        if (!this.item.translate) {
          this.item.translate = {}
        }
        if (!this.item.translate[this.lang]) {
          this.item.translate[this.lang] = {}
        }
        this.item.translate[this.lang][key] = value
      },

      openFileManager() {
        window.$('#file-manager').modal('show');
        this.$store.commit('onFileSelect', this.select);
      },
      select() {
        let images = this.$store.getters['fm/selectedItems'].map(i => encodeURI('/storage/' + i.path));
        this.item.image  = images[0]
      },
      up(){
        this.$emit('up')
      },
      down(){
        this.$emit('down')
      },
      remove(){
        this.$emit('remove')
      },


    }
  }
</script>
